// @flow
import ProductListSlider from 'fg-frontend/components/ProductListSlider';
import EshopPhotogallery from 'fg-frontend/components/EshopPhotogallery';
import EshopModel3D from 'fg-frontend/components/EshopModel3D';
import EshopImageMagnify from 'fg-frontend/components/EshopImageMagnify';
import EshopGalleryPopup from 'fg-frontend/components/EshopGalleryPopup';
import EshopOrderForm from 'fg-frontend/components/EshopOrderForm';
import BranchPicker from 'fg-frontend/src/components/BranchPicker';
import PersonalPickupSelect from './components/PersonalPickupSelect';


export default (props) => {
	switch (props.decorator || props.is) {
		case 'ProductListSlider':
			return ProductListSlider;
		case 'EshopPhotogallery':
			return EshopPhotogallery;
		case 'EshopModel3D':
			return EshopModel3D;
		case 'EshopImageMagnify':
			return EshopImageMagnify;
		case 'EshopGalleryPopup':
			return EshopGalleryPopup;
		case 'EshopOrderForm':
			return EshopOrderForm;
    case 'BranchPicker':
      return BranchPicker;
    case 'PersonalPickupSelect':
      return PersonalPickupSelect;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureEshopComponents.js